(function(){"use strict";try{if(typeof document<"u"){var t=document.createElement("style");t.appendChild(document.createTextNode("._tooltip_1xxpj_1{--rt-opacity: 1;--rt-transition-show-delay: .05s;--rt-transition-closing-delay: .05s;--tooltip-background-color: var(--uikit-dark-fixed-line-new-10-inverse, #313131);font-family:Hauss,sans-serif;font-weight:400;font-size:.75rem;line-height:1rem;letter-spacing:normal;width:max-content;padding:2px 7px;color:var(--uikit-dark-fixed-text-on-c-default-inverse, #f3f3f3);background-color:var(--tooltip-background-color);z-index:var(--ui-tooltip-z-index, 1)}._arrow_1xxpj_18{width:5.7px;height:5.7px}[class*=react-tooltip__place-top]>._arrow_1xxpj_18{transform:rotate(45deg) translateY(-2px)}[class*=react-tooltip__place-right]>._arrow_1xxpj_18{transform:rotate(135deg) translate(-1px,-2px)}[class*=react-tooltip__place-bottom]>._arrow_1xxpj_18{transform:rotate(225deg) translateY(-2px)}[class*=react-tooltip__place-left]>._arrow_1xxpj_18{transform:rotate(315deg) translate(-1px,-1px)}")),document.head.appendChild(t)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import Me, { createContext as hn, useState as q, useRef as Ee, useEffect as B, useContext as yn, useCallback as gn, useImperativeHandle as wn, useLayoutEffect as bn } from "react";
function _n(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var jt = { exports: {} }, gt = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Vt;
function xn() {
  if (Vt)
    return gt;
  Vt = 1;
  var e = Me, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), o = Object.prototype.hasOwnProperty, l = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(a, u, d) {
    var h, v = {}, x = null, m = null;
    d !== void 0 && (x = "" + d), u.key !== void 0 && (x = "" + u.key), u.ref !== void 0 && (m = u.ref);
    for (h in u)
      o.call(u, h) && !i.hasOwnProperty(h) && (v[h] = u[h]);
    if (a && a.defaultProps)
      for (h in u = a.defaultProps, u)
        v[h] === void 0 && (v[h] = u[h]);
    return { $$typeof: n, type: a, key: x, ref: m, props: v, _owner: l.current };
  }
  return gt.Fragment = r, gt.jsx = s, gt.jsxs = s, gt;
}
var wt = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Yt;
function En() {
  return Yt || (Yt = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Me, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), l = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), a = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), h = Symbol.for("react.suspense_list"), v = Symbol.for("react.memo"), x = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), w = Symbol.iterator, R = "@@iterator";
    function C(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = w && t[w] || t[R];
      return typeof c == "function" ? c : null;
    }
    var b = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function E(t) {
      {
        for (var c = arguments.length, f = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          f[y - 1] = arguments[y];
        L("error", t, f);
      }
    }
    function L(t, c, f) {
      {
        var y = b.ReactDebugCurrentFrame, g = y.getStackAddendum();
        g !== "" && (c += "%s", f = f.concat([g]));
        var j = f.map(function(k) {
          return String(k);
        });
        j.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, j);
      }
    }
    var F = !1, N = !1, te = !1, I = !1, re = !1, ae;
    ae = Symbol.for("react.module.reference");
    function ge(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === o || t === i || re || t === l || t === d || t === h || I || t === m || F || N || te || typeof t == "object" && t !== null && (t.$$typeof === x || t.$$typeof === v || t.$$typeof === s || t.$$typeof === a || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === ae || t.getModuleId !== void 0));
    }
    function me(t, c, f) {
      var y = t.displayName;
      if (y)
        return y;
      var g = c.displayName || c.name || "";
      return g !== "" ? f + "(" + g + ")" : f;
    }
    function K(t) {
      return t.displayName || "Context";
    }
    function X(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && E("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case o:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case l:
          return "StrictMode";
        case d:
          return "Suspense";
        case h:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case a:
            var c = t;
            return K(c) + ".Consumer";
          case s:
            var f = t;
            return K(f._context) + ".Provider";
          case u:
            return me(t, t.render, "ForwardRef");
          case v:
            var y = t.displayName || null;
            return y !== null ? y : X(t.type) || "Memo";
          case x: {
            var g = t, j = g._payload, k = g._init;
            try {
              return X(k(j));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var D = Object.assign, Y = 0, H, G, ve, Re, W, ke, Xe;
    function Ge() {
    }
    Ge.__reactDisabledLog = !0;
    function ut() {
      {
        if (Y === 0) {
          H = console.log, G = console.info, ve = console.warn, Re = console.error, W = console.group, ke = console.groupCollapsed, Xe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: Ge,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Y++;
      }
    }
    function yt() {
      {
        if (Y--, Y === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: D({}, t, {
              value: H
            }),
            info: D({}, t, {
              value: G
            }),
            warn: D({}, t, {
              value: ve
            }),
            error: D({}, t, {
              value: Re
            }),
            group: D({}, t, {
              value: W
            }),
            groupCollapsed: D({}, t, {
              value: ke
            }),
            groupEnd: D({}, t, {
              value: Xe
            })
          });
        }
        Y < 0 && E("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Le = b.ReactCurrentDispatcher, J;
    function we(t, c, f) {
      {
        if (J === void 0)
          try {
            throw Error();
          } catch (g) {
            var y = g.stack.trim().match(/\n( *(at )?)/);
            J = y && y[1] || "";
          }
        return `
` + J + t;
      }
    }
    var Z = !1, ne;
    {
      var Pe = typeof WeakMap == "function" ? WeakMap : Map;
      ne = new Pe();
    }
    function Ye(t, c) {
      if (!t || Z)
        return "";
      {
        var f = ne.get(t);
        if (f !== void 0)
          return f;
      }
      var y;
      Z = !0;
      var g = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var j;
      j = Le.current, Le.current = null, ut();
      try {
        if (c) {
          var k = function() {
            throw Error();
          };
          if (Object.defineProperty(k.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(k, []);
            } catch (ce) {
              y = ce;
            }
            Reflect.construct(t, [], k);
          } else {
            try {
              k.call();
            } catch (ce) {
              y = ce;
            }
            t.call(k.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ce) {
            y = ce;
          }
          t();
        }
      } catch (ce) {
        if (ce && y && typeof ce.stack == "string") {
          for (var T = ce.stack.split(`
`), ee = y.stack.split(`
`), M = T.length - 1, V = ee.length - 1; M >= 1 && V >= 0 && T[M] !== ee[V]; )
            V--;
          for (; M >= 1 && V >= 0; M--, V--)
            if (T[M] !== ee[V]) {
              if (M !== 1 || V !== 1)
                do
                  if (M--, V--, V < 0 || T[M] !== ee[V]) {
                    var A = `
` + T[M].replace(" at new ", " at ");
                    return t.displayName && A.includes("<anonymous>") && (A = A.replace("<anonymous>", t.displayName)), typeof t == "function" && ne.set(t, A), A;
                  }
                while (M >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Z = !1, Le.current = j, yt(), Error.prepareStackTrace = g;
      }
      var se = t ? t.displayName || t.name : "", dt = se ? we(se) : "";
      return typeof t == "function" && ne.set(t, dt), dt;
    }
    function ft(t, c, f) {
      return Ye(t, !1);
    }
    function Je(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function je(t, c, f) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ye(t, Je(t));
      if (typeof t == "string")
        return we(t);
      switch (t) {
        case d:
          return we("Suspense");
        case h:
          return we("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return ft(t.render);
          case v:
            return je(t.type, c, f);
          case x: {
            var y = t, g = y._payload, j = y._init;
            try {
              return je(j(g), c, f);
            } catch {
            }
          }
        }
      return "";
    }
    var De = Object.prototype.hasOwnProperty, Qe = {}, oe = b.ReactDebugCurrentFrame;
    function Ne(t) {
      if (t) {
        var c = t._owner, f = je(t.type, t._source, c ? c.type : null);
        oe.setExtraStackFrame(f);
      } else
        oe.setExtraStackFrame(null);
    }
    function ze(t, c, f, y, g) {
      {
        var j = Function.call.bind(De);
        for (var k in t)
          if (j(t, k)) {
            var T = void 0;
            try {
              if (typeof t[k] != "function") {
                var ee = Error((y || "React class") + ": " + f + " type `" + k + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[k] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              T = t[k](c, k, y, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (M) {
              T = M;
            }
            T && !(T instanceof Error) && (Ne(g), E("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", f, k, typeof T), Ne(null)), T instanceof Error && !(T.message in Qe) && (Qe[T.message] = !0, Ne(g), E("Failed %s type: %s", f, T.message), Ne(null));
          }
      }
    }
    var $e = Array.isArray;
    function $(t) {
      return $e(t);
    }
    function Ze(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, f = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return f;
      }
    }
    function et(t) {
      try {
        return He(t), !1;
      } catch {
        return !0;
      }
    }
    function He(t) {
      return "" + t;
    }
    function tt(t) {
      if (et(t))
        return E("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ze(t)), He(t);
    }
    var Se = b.ReactCurrentOwner, nt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, be, Fe, _e;
    _e = {};
    function Ue(t) {
      if (De.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function xe(t) {
      if (De.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rt(t, c) {
      if (typeof t.ref == "string" && Se.current && c && Se.current.stateNode !== c) {
        var f = X(Se.current.type);
        _e[f] || (E('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', X(Se.current.type), t.ref), _e[f] = !0);
      }
    }
    function ot(t, c) {
      {
        var f = function() {
          be || (be = !0, E("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        f.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: f,
          configurable: !0
        });
      }
    }
    function ue(t, c) {
      {
        var f = function() {
          Fe || (Fe = !0, E("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        f.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: f,
          configurable: !0
        });
      }
    }
    var ie = function(t, c, f, y, g, j, k) {
      var T = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: f,
        props: k,
        // Record the component responsible for creating this element.
        _owner: j
      };
      return T._store = {}, Object.defineProperty(T._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(T, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(T, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.freeze && (Object.freeze(T.props), Object.freeze(T)), T;
    };
    function it(t, c, f, y, g) {
      {
        var j, k = {}, T = null, ee = null;
        f !== void 0 && (tt(f), T = "" + f), xe(c) && (tt(c.key), T = "" + c.key), Ue(c) && (ee = c.ref, rt(c, g));
        for (j in c)
          De.call(c, j) && !nt.hasOwnProperty(j) && (k[j] = c[j]);
        if (t && t.defaultProps) {
          var M = t.defaultProps;
          for (j in M)
            k[j] === void 0 && (k[j] = M[j]);
        }
        if (T || ee) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          T && ot(k, V), ee && ue(k, V);
        }
        return ie(t, T, ee, g, y, Se.current, k);
      }
    }
    var Oe = b.ReactCurrentOwner, Te = b.ReactDebugCurrentFrame;
    function fe(t) {
      if (t) {
        var c = t._owner, f = je(t.type, t._source, c ? c.type : null);
        Te.setExtraStackFrame(f);
      } else
        Te.setExtraStackFrame(null);
    }
    var Ie;
    Ie = !1;
    function U(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function le() {
      {
        if (Oe.current) {
          var t = X(Oe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function _(t) {
      {
        if (t !== void 0) {
          var c = t.fileName.replace(/^.*[\\\/]/, ""), f = t.lineNumber;
          return `

Check your code at ` + c + ":" + f + ".";
        }
        return "";
      }
    }
    var P = {};
    function de(t) {
      {
        var c = le();
        if (!c) {
          var f = typeof t == "string" ? t : t.displayName || t.name;
          f && (c = `

Check the top-level render call using <` + f + ">.");
        }
        return c;
      }
    }
    function lt(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var f = de(c);
        if (P[f])
          return;
        P[f] = !0;
        var y = "";
        t && t._owner && t._owner !== Oe.current && (y = " It was passed a child from " + X(t._owner.type) + "."), fe(t), E('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', f, y), fe(null);
      }
    }
    function Ae(t, c) {
      {
        if (typeof t != "object")
          return;
        if ($(t))
          for (var f = 0; f < t.length; f++) {
            var y = t[f];
            U(y) && lt(y, c);
          }
        else if (U(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var g = C(t);
          if (typeof g == "function" && g !== t.entries)
            for (var j = g.call(t), k; !(k = j.next()).done; )
              U(k.value) && lt(k.value, c);
        }
      }
    }
    function he(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var f;
        if (typeof c == "function")
          f = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === v))
          f = c.propTypes;
        else
          return;
        if (f) {
          var y = X(c);
          ze(f, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !Ie) {
          Ie = !0;
          var g = X(c);
          E("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", g || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && E("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function We(t) {
      {
        for (var c = Object.keys(t.props), f = 0; f < c.length; f++) {
          var y = c[f];
          if (y !== "children" && y !== "key") {
            fe(t), E("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), fe(null);
            break;
          }
        }
        t.ref !== null && (fe(t), E("Invalid attribute `ref` supplied to `React.Fragment`."), fe(null));
      }
    }
    function p(t, c, f, y, g, j) {
      {
        var k = ge(t);
        if (!k) {
          var T = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (T += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = _(g);
          ee ? T += ee : T += le();
          var M;
          t === null ? M = "null" : $(t) ? M = "array" : t !== void 0 && t.$$typeof === n ? (M = "<" + (X(t.type) || "Unknown") + " />", T = " Did you accidentally export a JSX literal instead of a component?") : M = typeof t, E("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", M, T);
        }
        var V = it(t, c, f, g, j);
        if (V == null)
          return V;
        if (k) {
          var A = c.children;
          if (A !== void 0)
            if (y)
              if ($(A)) {
                for (var se = 0; se < A.length; se++)
                  Ae(A[se], t);
                Object.freeze && Object.freeze(A);
              } else
                E("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ae(A, t);
        }
        return t === o ? We(V) : he(V), V;
      }
    }
    function S(t, c, f) {
      return p(t, c, f, !0);
    }
    function O(t, c, f) {
      return p(t, c, f, !1);
    }
    var Q = O, z = S;
    wt.Fragment = o, wt.jsx = Q, wt.jsxs = z;
  }()), wt;
}
process.env.NODE_ENV === "production" ? jt.exports = xn() : jt.exports = En();
var Rn = jt.exports;
const vt = Math.min, st = Math.max, St = Math.round, Rt = Math.floor, qe = (e) => ({
  x: e,
  y: e
}), Sn = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, On = {
  start: "end",
  end: "start"
};
function Dt(e, n, r) {
  return st(e, vt(n, r));
}
function _t(e, n) {
  return typeof e == "function" ? e(n) : e;
}
function ct(e) {
  return e.split("-")[0];
}
function xt(e) {
  return e.split("-")[1];
}
function nn(e) {
  return e === "x" ? "y" : "x";
}
function Ft(e) {
  return e === "y" ? "height" : "width";
}
function At(e) {
  return ["top", "bottom"].includes(ct(e)) ? "y" : "x";
}
function It(e) {
  return nn(At(e));
}
function Tn(e, n, r) {
  r === void 0 && (r = !1);
  const o = xt(e), l = It(e), i = Ft(l);
  let s = l === "x" ? o === (r ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return n.reference[i] > n.floating[i] && (s = Ot(s)), [s, Ot(s)];
}
function An(e) {
  const n = Ot(e);
  return [Nt(e), n, Nt(n)];
}
function Nt(e) {
  return e.replace(/start|end/g, (n) => On[n]);
}
function Cn(e, n, r) {
  const o = ["left", "right"], l = ["right", "left"], i = ["top", "bottom"], s = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return r ? n ? l : o : n ? o : l;
    case "left":
    case "right":
      return n ? i : s;
    default:
      return [];
  }
}
function kn(e, n, r, o) {
  const l = xt(e);
  let i = Cn(ct(e), r === "start", o);
  return l && (i = i.map((s) => s + "-" + l), n && (i = i.concat(i.map(Nt)))), i;
}
function Ot(e) {
  return e.replace(/left|right|bottom|top/g, (n) => Sn[n]);
}
function Ln(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function rn(e) {
  return typeof e != "number" ? Ln(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Tt(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function zt(e, n, r) {
  let {
    reference: o,
    floating: l
  } = e;
  const i = At(n), s = It(n), a = Ft(s), u = ct(n), d = i === "y", h = o.x + o.width / 2 - l.width / 2, v = o.y + o.height / 2 - l.height / 2, x = o[a] / 2 - l[a] / 2;
  let m;
  switch (u) {
    case "top":
      m = {
        x: h,
        y: o.y - l.height
      };
      break;
    case "bottom":
      m = {
        x: h,
        y: o.y + o.height
      };
      break;
    case "right":
      m = {
        x: o.x + o.width,
        y: v
      };
      break;
    case "left":
      m = {
        x: o.x - l.width,
        y: v
      };
      break;
    default:
      m = {
        x: o.x,
        y: o.y
      };
  }
  switch (xt(n)) {
    case "start":
      m[s] -= x * (r && d ? -1 : 1);
      break;
    case "end":
      m[s] += x * (r && d ? -1 : 1);
      break;
  }
  return m;
}
const Pn = async (e, n, r) => {
  const {
    placement: o = "bottom",
    strategy: l = "absolute",
    middleware: i = [],
    platform: s
  } = r, a = i.filter(Boolean), u = await (s.isRTL == null ? void 0 : s.isRTL(n));
  let d = await s.getElementRects({
    reference: e,
    floating: n,
    strategy: l
  }), {
    x: h,
    y: v
  } = zt(d, o, u), x = o, m = {}, w = 0;
  for (let R = 0; R < a.length; R++) {
    const {
      name: C,
      fn: b
    } = a[R], {
      x: E,
      y: L,
      data: F,
      reset: N
    } = await b({
      x: h,
      y: v,
      initialPlacement: o,
      placement: x,
      strategy: l,
      middlewareData: m,
      rects: d,
      platform: s,
      elements: {
        reference: e,
        floating: n
      }
    });
    if (h = E ?? h, v = L ?? v, m = {
      ...m,
      [C]: {
        ...m[C],
        ...F
      }
    }, N && w <= 50) {
      w++, typeof N == "object" && (N.placement && (x = N.placement), N.rects && (d = N.rects === !0 ? await s.getElementRects({
        reference: e,
        floating: n,
        strategy: l
      }) : N.rects), {
        x: h,
        y: v
      } = zt(d, x, u)), R = -1;
      continue;
    }
  }
  return {
    x: h,
    y: v,
    placement: x,
    strategy: l,
    middlewareData: m
  };
};
async function on(e, n) {
  var r;
  n === void 0 && (n = {});
  const {
    x: o,
    y: l,
    platform: i,
    rects: s,
    elements: a,
    strategy: u
  } = e, {
    boundary: d = "clippingAncestors",
    rootBoundary: h = "viewport",
    elementContext: v = "floating",
    altBoundary: x = !1,
    padding: m = 0
  } = _t(n, e), w = rn(m), C = a[x ? v === "floating" ? "reference" : "floating" : v], b = Tt(await i.getClippingRect({
    element: (r = await (i.isElement == null ? void 0 : i.isElement(C))) == null || r ? C : C.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(a.floating)),
    boundary: d,
    rootBoundary: h,
    strategy: u
  })), E = v === "floating" ? {
    ...s.floating,
    x: o,
    y: l
  } : s.reference, L = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(a.floating)), F = await (i.isElement == null ? void 0 : i.isElement(L)) ? await (i.getScale == null ? void 0 : i.getScale(L)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, N = Tt(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: E,
    offsetParent: L,
    strategy: u
  }) : E);
  return {
    top: (b.top - N.top + w.top) / F.y,
    bottom: (N.bottom - b.bottom + w.bottom) / F.y,
    left: (b.left - N.left + w.left) / F.x,
    right: (N.right - b.right + w.right) / F.x
  };
}
const jn = (e) => ({
  name: "arrow",
  options: e,
  async fn(n) {
    const {
      x: r,
      y: o,
      placement: l,
      rects: i,
      platform: s,
      elements: a,
      middlewareData: u
    } = n, {
      element: d,
      padding: h = 0
    } = _t(e, n) || {};
    if (d == null)
      return {};
    const v = rn(h), x = {
      x: r,
      y: o
    }, m = It(l), w = Ft(m), R = await s.getDimensions(d), C = m === "y", b = C ? "top" : "left", E = C ? "bottom" : "right", L = C ? "clientHeight" : "clientWidth", F = i.reference[w] + i.reference[m] - x[m] - i.floating[w], N = x[m] - i.reference[m], te = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(d));
    let I = te ? te[L] : 0;
    (!I || !await (s.isElement == null ? void 0 : s.isElement(te))) && (I = a.floating[L] || i.floating[w]);
    const re = F / 2 - N / 2, ae = I / 2 - R[w] / 2 - 1, ge = vt(v[b], ae), me = vt(v[E], ae), K = ge, X = I - R[w] - me, D = I / 2 - R[w] / 2 + re, Y = Dt(K, D, X), H = !u.arrow && xt(l) != null && D != Y && i.reference[w] / 2 - (D < K ? ge : me) - R[w] / 2 < 0, G = H ? D < K ? D - K : D - X : 0;
    return {
      [m]: x[m] + G,
      data: {
        [m]: Y,
        centerOffset: D - Y - G,
        ...H && {
          alignmentOffset: G
        }
      },
      reset: H
    };
  }
}), Dn = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(n) {
      var r, o;
      const {
        placement: l,
        middlewareData: i,
        rects: s,
        initialPlacement: a,
        platform: u,
        elements: d
      } = n, {
        mainAxis: h = !0,
        crossAxis: v = !0,
        fallbackPlacements: x,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: w = "none",
        flipAlignment: R = !0,
        ...C
      } = _t(e, n);
      if ((r = i.arrow) != null && r.alignmentOffset)
        return {};
      const b = ct(l), E = ct(a) === a, L = await (u.isRTL == null ? void 0 : u.isRTL(d.floating)), F = x || (E || !R ? [Ot(a)] : An(a));
      !x && w !== "none" && F.push(...kn(a, R, w, L));
      const N = [a, ...F], te = await on(n, C), I = [];
      let re = ((o = i.flip) == null ? void 0 : o.overflows) || [];
      if (h && I.push(te[b]), v) {
        const K = Tn(l, s, L);
        I.push(te[K[0]], te[K[1]]);
      }
      if (re = [...re, {
        placement: l,
        overflows: I
      }], !I.every((K) => K <= 0)) {
        var ae, ge;
        const K = (((ae = i.flip) == null ? void 0 : ae.index) || 0) + 1, X = N[K];
        if (X)
          return {
            data: {
              index: K,
              overflows: re
            },
            reset: {
              placement: X
            }
          };
        let D = (ge = re.filter((Y) => Y.overflows[0] <= 0).sort((Y, H) => Y.overflows[1] - H.overflows[1])[0]) == null ? void 0 : ge.placement;
        if (!D)
          switch (m) {
            case "bestFit": {
              var me;
              const Y = (me = re.map((H) => [H.placement, H.overflows.filter((G) => G > 0).reduce((G, ve) => G + ve, 0)]).sort((H, G) => H[1] - G[1])[0]) == null ? void 0 : me[0];
              Y && (D = Y);
              break;
            }
            case "initialPlacement":
              D = a;
              break;
          }
        if (l !== D)
          return {
            reset: {
              placement: D
            }
          };
      }
      return {};
    }
  };
};
async function Nn(e, n) {
  const {
    placement: r,
    platform: o,
    elements: l
  } = e, i = await (o.isRTL == null ? void 0 : o.isRTL(l.floating)), s = ct(r), a = xt(r), u = At(r) === "y", d = ["left", "top"].includes(s) ? -1 : 1, h = i && u ? -1 : 1, v = _t(n, e);
  let {
    mainAxis: x,
    crossAxis: m,
    alignmentAxis: w
  } = typeof v == "number" ? {
    mainAxis: v,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...v
  };
  return a && typeof w == "number" && (m = a === "end" ? w * -1 : w), u ? {
    x: m * h,
    y: x * d
  } : {
    x: x * d,
    y: m * h
  };
}
const $n = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(n) {
      const {
        x: r,
        y: o
      } = n, l = await Nn(n, e);
      return {
        x: r + l.x,
        y: o + l.y,
        data: l
      };
    }
  };
}, Fn = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(n) {
      const {
        x: r,
        y: o,
        placement: l
      } = n, {
        mainAxis: i = !0,
        crossAxis: s = !1,
        limiter: a = {
          fn: (C) => {
            let {
              x: b,
              y: E
            } = C;
            return {
              x: b,
              y: E
            };
          }
        },
        ...u
      } = _t(e, n), d = {
        x: r,
        y: o
      }, h = await on(n, u), v = At(ct(l)), x = nn(v);
      let m = d[x], w = d[v];
      if (i) {
        const C = x === "y" ? "top" : "left", b = x === "y" ? "bottom" : "right", E = m + h[C], L = m - h[b];
        m = Dt(E, m, L);
      }
      if (s) {
        const C = v === "y" ? "top" : "left", b = v === "y" ? "bottom" : "right", E = w + h[C], L = w - h[b];
        w = Dt(E, w, L);
      }
      const R = a.fn({
        ...n,
        [x]: m,
        [v]: w
      });
      return {
        ...R,
        data: {
          x: R.x - r,
          y: R.y - o
        }
      };
    }
  };
};
function Ke(e) {
  return ln(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function pe(e) {
  var n;
  return (e == null || (n = e.ownerDocument) == null ? void 0 : n.defaultView) || window;
}
function Ve(e) {
  var n;
  return (n = (ln(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : n.documentElement;
}
function ln(e) {
  return e instanceof Node || e instanceof pe(e).Node;
}
function Be(e) {
  return e instanceof Element || e instanceof pe(e).Element;
}
function Ce(e) {
  return e instanceof HTMLElement || e instanceof pe(e).HTMLElement;
}
function Ht(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof pe(e).ShadowRoot;
}
function Et(e) {
  const {
    overflow: n,
    overflowX: r,
    overflowY: o,
    display: l
  } = ye(e);
  return /auto|scroll|overlay|hidden|clip/.test(n + o + r) && !["inline", "contents"].includes(l);
}
function In(e) {
  return ["table", "td", "th"].includes(Ke(e));
}
function Wt(e) {
  const n = Mt(), r = ye(e);
  return r.transform !== "none" || r.perspective !== "none" || (r.containerType ? r.containerType !== "normal" : !1) || !n && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !n && (r.filter ? r.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((o) => (r.willChange || "").includes(o)) || ["paint", "layout", "strict", "content"].some((o) => (r.contain || "").includes(o));
}
function Wn(e) {
  let n = ht(e);
  for (; Ce(n) && !Ct(n); ) {
    if (Wt(n))
      return n;
    n = ht(n);
  }
  return null;
}
function Mt() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Ct(e) {
  return ["html", "body", "#document"].includes(Ke(e));
}
function ye(e) {
  return pe(e).getComputedStyle(e);
}
function kt(e) {
  return Be(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function ht(e) {
  if (Ke(e) === "html")
    return e;
  const n = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Ht(e) && e.host || // Fallback.
    Ve(e)
  );
  return Ht(n) ? n.host : n;
}
function sn(e) {
  const n = ht(e);
  return Ct(n) ? e.ownerDocument ? e.ownerDocument.body : e.body : Ce(n) && Et(n) ? n : sn(n);
}
function bt(e, n, r) {
  var o;
  n === void 0 && (n = []), r === void 0 && (r = !0);
  const l = sn(e), i = l === ((o = e.ownerDocument) == null ? void 0 : o.body), s = pe(l);
  return i ? n.concat(s, s.visualViewport || [], Et(l) ? l : [], s.frameElement && r ? bt(s.frameElement) : []) : n.concat(l, bt(l, [], r));
}
function cn(e) {
  const n = ye(e);
  let r = parseFloat(n.width) || 0, o = parseFloat(n.height) || 0;
  const l = Ce(e), i = l ? e.offsetWidth : r, s = l ? e.offsetHeight : o, a = St(r) !== i || St(o) !== s;
  return a && (r = i, o = s), {
    width: r,
    height: o,
    $: a
  };
}
function Bt(e) {
  return Be(e) ? e : e.contextElement;
}
function mt(e) {
  const n = Bt(e);
  if (!Ce(n))
    return qe(1);
  const r = n.getBoundingClientRect(), {
    width: o,
    height: l,
    $: i
  } = cn(n);
  let s = (i ? St(r.width) : r.width) / o, a = (i ? St(r.height) : r.height) / l;
  return (!s || !Number.isFinite(s)) && (s = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: s,
    y: a
  };
}
const Mn = /* @__PURE__ */ qe(0);
function an(e) {
  const n = pe(e);
  return !Mt() || !n.visualViewport ? Mn : {
    x: n.visualViewport.offsetLeft,
    y: n.visualViewport.offsetTop
  };
}
function Bn(e, n, r) {
  return n === void 0 && (n = !1), !r || n && r !== pe(e) ? !1 : n;
}
function at(e, n, r, o) {
  n === void 0 && (n = !1), r === void 0 && (r = !1);
  const l = e.getBoundingClientRect(), i = Bt(e);
  let s = qe(1);
  n && (o ? Be(o) && (s = mt(o)) : s = mt(e));
  const a = Bn(i, r, o) ? an(i) : qe(0);
  let u = (l.left + a.x) / s.x, d = (l.top + a.y) / s.y, h = l.width / s.x, v = l.height / s.y;
  if (i) {
    const x = pe(i), m = o && Be(o) ? pe(o) : o;
    let w = x.frameElement;
    for (; w && o && m !== x; ) {
      const R = mt(w), C = w.getBoundingClientRect(), b = ye(w), E = C.left + (w.clientLeft + parseFloat(b.paddingLeft)) * R.x, L = C.top + (w.clientTop + parseFloat(b.paddingTop)) * R.y;
      u *= R.x, d *= R.y, h *= R.x, v *= R.y, u += E, d += L, w = pe(w).frameElement;
    }
  }
  return Tt({
    width: h,
    height: v,
    x: u,
    y: d
  });
}
function Vn(e) {
  let {
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const l = Ce(r), i = Ve(r);
  if (r === i)
    return n;
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  }, a = qe(1);
  const u = qe(0);
  if ((l || !l && o !== "fixed") && ((Ke(r) !== "body" || Et(i)) && (s = kt(r)), Ce(r))) {
    const d = at(r);
    a = mt(r), u.x = d.x + r.clientLeft, u.y = d.y + r.clientTop;
  }
  return {
    width: n.width * a.x,
    height: n.height * a.y,
    x: n.x * a.x - s.scrollLeft * a.x + u.x,
    y: n.y * a.y - s.scrollTop * a.y + u.y
  };
}
function Yn(e) {
  return Array.from(e.getClientRects());
}
function un(e) {
  return at(Ve(e)).left + kt(e).scrollLeft;
}
function zn(e) {
  const n = Ve(e), r = kt(e), o = e.ownerDocument.body, l = st(n.scrollWidth, n.clientWidth, o.scrollWidth, o.clientWidth), i = st(n.scrollHeight, n.clientHeight, o.scrollHeight, o.clientHeight);
  let s = -r.scrollLeft + un(e);
  const a = -r.scrollTop;
  return ye(o).direction === "rtl" && (s += st(n.clientWidth, o.clientWidth) - l), {
    width: l,
    height: i,
    x: s,
    y: a
  };
}
function Hn(e, n) {
  const r = pe(e), o = Ve(e), l = r.visualViewport;
  let i = o.clientWidth, s = o.clientHeight, a = 0, u = 0;
  if (l) {
    i = l.width, s = l.height;
    const d = Mt();
    (!d || d && n === "fixed") && (a = l.offsetLeft, u = l.offsetTop);
  }
  return {
    width: i,
    height: s,
    x: a,
    y: u
  };
}
function Un(e, n) {
  const r = at(e, !0, n === "fixed"), o = r.top + e.clientTop, l = r.left + e.clientLeft, i = Ce(e) ? mt(e) : qe(1), s = e.clientWidth * i.x, a = e.clientHeight * i.y, u = l * i.x, d = o * i.y;
  return {
    width: s,
    height: a,
    x: u,
    y: d
  };
}
function Ut(e, n, r) {
  let o;
  if (n === "viewport")
    o = Hn(e, r);
  else if (n === "document")
    o = zn(Ve(e));
  else if (Be(n))
    o = Un(n, r);
  else {
    const l = an(e);
    o = {
      ...n,
      x: n.x - l.x,
      y: n.y - l.y
    };
  }
  return Tt(o);
}
function fn(e, n) {
  const r = ht(e);
  return r === n || !Be(r) || Ct(r) ? !1 : ye(r).position === "fixed" || fn(r, n);
}
function qn(e, n) {
  const r = n.get(e);
  if (r)
    return r;
  let o = bt(e, [], !1).filter((a) => Be(a) && Ke(a) !== "body"), l = null;
  const i = ye(e).position === "fixed";
  let s = i ? ht(e) : e;
  for (; Be(s) && !Ct(s); ) {
    const a = ye(s), u = Wt(s);
    !u && a.position === "fixed" && (l = null), (i ? !u && !l : !u && a.position === "static" && !!l && ["absolute", "fixed"].includes(l.position) || Et(s) && !u && fn(e, s)) ? o = o.filter((h) => h !== s) : l = a, s = ht(s);
  }
  return n.set(e, o), o;
}
function Kn(e) {
  let {
    element: n,
    boundary: r,
    rootBoundary: o,
    strategy: l
  } = e;
  const s = [...r === "clippingAncestors" ? qn(n, this._c) : [].concat(r), o], a = s[0], u = s.reduce((d, h) => {
    const v = Ut(n, h, l);
    return d.top = st(v.top, d.top), d.right = vt(v.right, d.right), d.bottom = vt(v.bottom, d.bottom), d.left = st(v.left, d.left), d;
  }, Ut(n, a, l));
  return {
    width: u.right - u.left,
    height: u.bottom - u.top,
    x: u.left,
    y: u.top
  };
}
function Xn(e) {
  return cn(e);
}
function Gn(e, n, r) {
  const o = Ce(n), l = Ve(n), i = r === "fixed", s = at(e, !0, i, n);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const u = qe(0);
  if (o || !o && !i)
    if ((Ke(n) !== "body" || Et(l)) && (a = kt(n)), o) {
      const d = at(n, !0, i, n);
      u.x = d.x + n.clientLeft, u.y = d.y + n.clientTop;
    } else
      l && (u.x = un(l));
  return {
    x: s.left + a.scrollLeft - u.x,
    y: s.top + a.scrollTop - u.y,
    width: s.width,
    height: s.height
  };
}
function qt(e, n) {
  return !Ce(e) || ye(e).position === "fixed" ? null : n ? n(e) : e.offsetParent;
}
function dn(e, n) {
  const r = pe(e);
  if (!Ce(e))
    return r;
  let o = qt(e, n);
  for (; o && In(o) && ye(o).position === "static"; )
    o = qt(o, n);
  return o && (Ke(o) === "html" || Ke(o) === "body" && ye(o).position === "static" && !Wt(o)) ? r : o || Wn(e) || r;
}
const Jn = async function(e) {
  let {
    reference: n,
    floating: r,
    strategy: o
  } = e;
  const l = this.getOffsetParent || dn, i = this.getDimensions;
  return {
    reference: Gn(n, await l(r), o),
    floating: {
      x: 0,
      y: 0,
      ...await i(r)
    }
  };
};
function Qn(e) {
  return ye(e).direction === "rtl";
}
const Zn = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Vn,
  getDocumentElement: Ve,
  getClippingRect: Kn,
  getOffsetParent: dn,
  getElementRects: Jn,
  getClientRects: Yn,
  getDimensions: Xn,
  getScale: mt,
  isElement: Be,
  isRTL: Qn
};
function er(e, n) {
  let r = null, o;
  const l = Ve(e);
  function i() {
    clearTimeout(o), r && r.disconnect(), r = null;
  }
  function s(a, u) {
    a === void 0 && (a = !1), u === void 0 && (u = 1), i();
    const {
      left: d,
      top: h,
      width: v,
      height: x
    } = e.getBoundingClientRect();
    if (a || n(), !v || !x)
      return;
    const m = Rt(h), w = Rt(l.clientWidth - (d + v)), R = Rt(l.clientHeight - (h + x)), C = Rt(d), E = {
      rootMargin: -m + "px " + -w + "px " + -R + "px " + -C + "px",
      threshold: st(0, vt(1, u)) || 1
    };
    let L = !0;
    function F(N) {
      const te = N[0].intersectionRatio;
      if (te !== u) {
        if (!L)
          return s();
        te ? s(!1, te) : o = setTimeout(() => {
          s(!1, 1e-7);
        }, 100);
      }
      L = !1;
    }
    try {
      r = new IntersectionObserver(F, {
        ...E,
        // Handle <iframe>s
        root: l.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(F, E);
    }
    r.observe(e);
  }
  return s(!0), i;
}
function tr(e, n, r, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: l = !0,
    ancestorResize: i = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: u = !1
  } = o, d = Bt(e), h = l || i ? [...d ? bt(d) : [], ...bt(n)] : [];
  h.forEach((b) => {
    l && b.addEventListener("scroll", r, {
      passive: !0
    }), i && b.addEventListener("resize", r);
  });
  const v = d && a ? er(d, r) : null;
  let x = -1, m = null;
  s && (m = new ResizeObserver((b) => {
    let [E] = b;
    E && E.target === d && m && (m.unobserve(n), cancelAnimationFrame(x), x = requestAnimationFrame(() => {
      m && m.observe(n);
    })), r();
  }), d && !u && m.observe(d), m.observe(n));
  let w, R = u ? at(e) : null;
  u && C();
  function C() {
    const b = at(e);
    R && (b.x !== R.x || b.y !== R.y || b.width !== R.width || b.height !== R.height) && r(), R = b, w = requestAnimationFrame(C);
  }
  return r(), () => {
    h.forEach((b) => {
      l && b.removeEventListener("scroll", r), i && b.removeEventListener("resize", r);
    }), v && v(), m && m.disconnect(), m = null, u && cancelAnimationFrame(w);
  };
}
const Kt = (e, n, r) => {
  const o = /* @__PURE__ */ new Map(), l = {
    platform: Zn,
    ...r
  }, i = {
    ...l.platform,
    _c: o
  };
  return Pn(e, n, {
    ...l,
    platform: i
  });
};
var pn = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var n = {}.hasOwnProperty;
    function r() {
      for (var i = "", s = 0; s < arguments.length; s++) {
        var a = arguments[s];
        a && (i = l(i, o(a)));
      }
      return i;
    }
    function o(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return r.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var s = "";
      for (var a in i)
        n.call(i, a) && i[a] && (s = l(s, a));
      return s;
    }
    function l(i, s) {
      return s ? i ? i + " " + s : i + s : i;
    }
    e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
  })();
})(pn);
var nr = pn.exports;
const $t = /* @__PURE__ */ _n(nr);
/*
* React Tooltip
* {@link https://github.com/ReactTooltip/react-tooltip}
* @copyright ReactTooltip Team
* @license MIT
*/
const rr = "react-tooltip-core-styles", or = "react-tooltip-base-styles", Xt = { core: !1, base: !1 };
function Gt({ css: e, id: n = or, type: r = "base", ref: o }) {
  var l, i;
  if (!e || typeof document > "u" || Xt[r] || r === "core" && typeof process < "u" && (!((l = process == null ? void 0 : process.env) === null || l === void 0) && l.REACT_TOOLTIP_DISABLE_CORE_STYLES) || r !== "base" && typeof process < "u" && (!((i = process == null ? void 0 : process.env) === null || i === void 0) && i.REACT_TOOLTIP_DISABLE_BASE_STYLES))
    return;
  r === "core" && (n = rr), o || (o = {});
  const { insertAt: s } = o;
  if (document.getElementById(n))
    return void console.warn(`[react-tooltip] Element with id '${n}' already exists. Call \`removeStyle()\` first`);
  const a = document.head || document.getElementsByTagName("head")[0], u = document.createElement("style");
  u.id = n, u.type = "text/css", s === "top" && a.firstChild ? a.insertBefore(u, a.firstChild) : a.appendChild(u), u.styleSheet ? u.styleSheet.cssText = e : u.appendChild(document.createTextNode(e)), Xt[r] = !0;
}
const Jt = (e, n, r) => {
  let o = null;
  const l = function(...i) {
    const s = () => {
      o = null, r || e.apply(this, i);
    };
    r && !o && (e.apply(this, i), o = setTimeout(s, n)), r || (o && clearTimeout(o), o = setTimeout(s, n));
  };
  return l.cancel = () => {
    o && (clearTimeout(o), o = null);
  }, l;
}, ir = "DEFAULT_TOOLTIP_ID", lr = { anchorRefs: /* @__PURE__ */ new Set(), activeAnchor: { current: null }, attach: () => {
}, detach: () => {
}, setActiveAnchor: () => {
} }, sr = hn({ getTooltipData: () => lr });
function mn(e = ir) {
  return yn(sr).getTooltipData(e);
}
const cr = typeof window < "u" ? bn : B, ar = (e) => {
  if (!(e instanceof HTMLElement || e instanceof SVGElement))
    return !1;
  const n = getComputedStyle(e);
  return ["overflow", "overflow-x", "overflow-y"].some((r) => {
    const o = n.getPropertyValue(r);
    return o === "auto" || o === "scroll";
  });
}, Qt = (e) => {
  if (!e)
    return null;
  let n = e.parentElement;
  for (; n; ) {
    if (ar(n))
      return n;
    n = n.parentElement;
  }
  return document.scrollingElement || document.documentElement;
}, Zt = async ({ elementReference: e = null, tooltipReference: n = null, tooltipArrowReference: r = null, place: o = "top", offset: l = 10, strategy: i = "absolute", middlewares: s = [$n(Number(l)), Dn({ fallbackAxisSideDirection: "start" }), Fn({ padding: 5 })], border: a }) => {
  if (!e)
    return { tooltipStyles: {}, tooltipArrowStyles: {}, place: o };
  if (n === null)
    return { tooltipStyles: {}, tooltipArrowStyles: {}, place: o };
  const u = s;
  return r ? (u.push(jn({ element: r, padding: 5 })), Kt(e, n, { placement: o, strategy: i, middleware: u }).then(({ x: d, y: h, placement: v, middlewareData: x }) => {
    var m, w;
    const R = { left: `${d}px`, top: `${h}px`, border: a }, { x: C, y: b } = (m = x.arrow) !== null && m !== void 0 ? m : { x: 0, y: 0 }, E = (w = { top: "bottom", right: "left", bottom: "top", left: "right" }[v.split("-")[0]]) !== null && w !== void 0 ? w : "bottom", L = a && { borderBottom: a, borderRight: a };
    let F = 0;
    if (a) {
      const N = `${a}`.match(/(\d+)px/);
      F = N != null && N[1] ? Number(N[1]) : 1;
    }
    return { tooltipStyles: R, tooltipArrowStyles: { left: C != null ? `${C}px` : "", top: b != null ? `${b}px` : "", right: "", bottom: "", ...L, [E]: `-${4 + F}px` }, place: v };
  })) : Kt(e, n, { placement: "bottom", strategy: i, middleware: u }).then(({ x: d, y: h, placement: v }) => ({ tooltipStyles: { left: `${d}px`, top: `${h}px` }, tooltipArrowStyles: {}, place: v }));
};
var pt = { tooltip: "core-styles-module_tooltip__3vRRp", fixed: "core-styles-module_fixed__pcSol", arrow: "core-styles-module_arrow__cvMwQ", noArrow: "core-styles-module_noArrow__xock6", clickable: "core-styles-module_clickable__ZuTTB", show: "core-styles-module_show__Nt9eE", closing: "core-styles-module_closing__sGnxF" }, Pt = { tooltip: "styles-module_tooltip__mnnfp", arrow: "styles-module_arrow__K0L3T", dark: "styles-module_dark__xNqje", light: "styles-module_light__Z6W-X", success: "styles-module_success__A2AKt", warning: "styles-module_warning__SCK0X", error: "styles-module_error__JvumD", info: "styles-module_info__BWdHW" };
const ur = ({ forwardRef: e, id: n, className: r, classNameArrow: o, variant: l = "dark", anchorId: i, anchorSelect: s, place: a = "top", offset: u = 10, events: d = ["hover"], openOnClick: h = !1, positionStrategy: v = "absolute", middlewares: x, wrapper: m, delayShow: w = 0, delayHide: R = 0, float: C = !1, hidden: b = !1, noArrow: E = !1, clickable: L = !1, closeOnEsc: F = !1, closeOnScroll: N = !1, closeOnResize: te = !1, openEvents: I, closeEvents: re, globalCloseEvents: ae, imperativeModeOnly: ge, style: me, position: K, afterShow: X, afterHide: D, content: Y, contentWrapperRef: H, isOpen: G, defaultIsOpen: ve = !1, setIsOpen: Re, activeAnchor: W, setActiveAnchor: ke, border: Xe, opacity: Ge, arrowColor: ut, role: yt = "tooltip" }) => {
  var Le;
  const J = Ee(null), we = Ee(null), Z = Ee(null), ne = Ee(null), Pe = Ee(null), [Ye, ft] = q(a), [Je, je] = q({}), [De, Qe] = q({}), [oe, Ne] = q(!1), [ze, $e] = q(!1), [$, Ze] = q(null), et = Ee(!1), He = Ee(null), { anchorRefs: tt, setActiveAnchor: Se } = mn(n), nt = Ee(!1), [be, Fe] = q([]), _e = Ee(!1), Ue = h || d.includes("click"), xe = Ue || (I == null ? void 0 : I.click) || (I == null ? void 0 : I.dblclick) || (I == null ? void 0 : I.mousedown), rt = I ? { ...I } : { mouseenter: !0, focus: !0, click: !1, dblclick: !1, mousedown: !1 };
  !I && Ue && Object.assign(rt, { mouseenter: !1, focus: !1, click: !0 });
  const ot = re ? { ...re } : { mouseleave: !0, blur: !0, click: !1, dblclick: !1, mouseup: !1 };
  !re && Ue && Object.assign(ot, { mouseleave: !1, blur: !1 });
  const ue = ae ? { ...ae } : { escape: F || !1, scroll: N || !1, resize: te || !1, clickOutsideAnchor: xe || !1 };
  ge && (Object.assign(rt, { mouseenter: !1, focus: !1, click: !1, dblclick: !1, mousedown: !1 }), Object.assign(ot, { mouseleave: !1, blur: !1, click: !1, dblclick: !1, mouseup: !1 }), Object.assign(ue, { escape: !1, scroll: !1, resize: !1, clickOutsideAnchor: !1 })), cr(() => (_e.current = !0, () => {
    _e.current = !1;
  }), []);
  const ie = (p) => {
    _e.current && (p && $e(!0), setTimeout(() => {
      _e.current && (Re == null || Re(p), G === void 0 && Ne(p));
    }, 10));
  };
  B(() => {
    if (G === void 0)
      return () => null;
    G && $e(!0);
    const p = setTimeout(() => {
      Ne(G);
    }, 10);
    return () => {
      clearTimeout(p);
    };
  }, [G]), B(() => {
    if (oe !== et.current)
      if (Pe.current && clearTimeout(Pe.current), et.current = oe, oe)
        X == null || X();
      else {
        const p = ((S) => {
          const O = S.match(/^([\d.]+)(m?s?)$/);
          if (!O)
            return 0;
          const [, Q, z] = O;
          return z !== "s" && z !== "ms" ? 0 : Number(Q) * (z === "ms" ? 1 : 1e3);
        })(getComputedStyle(document.body).getPropertyValue("--rt-transition-show-delay"));
        Pe.current = setTimeout(() => {
          $e(!1), Ze(null), D == null || D();
        }, p + 25);
      }
  }, [oe]);
  const it = (p = w) => {
    Z.current && clearTimeout(Z.current), Z.current = setTimeout(() => {
      ie(!0);
    }, p);
  }, Oe = (p = R) => {
    ne.current && clearTimeout(ne.current), ne.current = setTimeout(() => {
      nt.current || ie(!1);
    }, p);
  }, Te = (p) => {
    var S;
    if (!p)
      return;
    const O = (S = p.currentTarget) !== null && S !== void 0 ? S : p.target;
    if (!(O != null && O.isConnected))
      return ke(null), void Se({ current: null });
    w ? it() : ie(!0), ke(O), Se({ current: O }), ne.current && clearTimeout(ne.current);
  }, fe = () => {
    L ? Oe(R || 100) : R ? Oe() : ie(!1), Z.current && clearTimeout(Z.current);
  }, Ie = ({ x: p, y: S }) => {
    var O;
    const Q = { getBoundingClientRect: () => ({ x: p, y: S, width: 0, height: 0, top: S, left: p, right: p, bottom: S }) };
    Zt({ place: (O = $ == null ? void 0 : $.place) !== null && O !== void 0 ? O : a, offset: u, elementReference: Q, tooltipReference: J.current, tooltipArrowReference: we.current, strategy: v, middlewares: x, border: Xe }).then((z) => {
      Object.keys(z.tooltipStyles).length && je(z.tooltipStyles), Object.keys(z.tooltipArrowStyles).length && Qe(z.tooltipArrowStyles), ft(z.place);
    });
  }, U = (p) => {
    if (!p)
      return;
    const S = p, O = { x: S.clientX, y: S.clientY };
    Ie(O), He.current = O;
  }, le = (p) => {
    var S;
    if (!oe)
      return;
    const O = p.target;
    !((S = J.current) === null || S === void 0) && S.contains(O) || [document.querySelector(`[id='${i}']`), ...be].some((Q) => Q == null ? void 0 : Q.contains(O)) || (ie(!1), Z.current && clearTimeout(Z.current));
  }, _ = Jt(Te, 50, !0), P = Jt(fe, 50, !0), de = (p) => {
    P.cancel(), _(p);
  }, lt = () => {
    _.cancel(), P();
  }, Ae = gn(() => {
    var p, S;
    const O = (p = $ == null ? void 0 : $.position) !== null && p !== void 0 ? p : K;
    O ? Ie(O) : C ? He.current && Ie(He.current) : W != null && W.isConnected && Zt({ place: (S = $ == null ? void 0 : $.place) !== null && S !== void 0 ? S : a, offset: u, elementReference: W, tooltipReference: J.current, tooltipArrowReference: we.current, strategy: v, middlewares: x, border: Xe }).then((Q) => {
      _e.current && (Object.keys(Q.tooltipStyles).length && je(Q.tooltipStyles), Object.keys(Q.tooltipArrowStyles).length && Qe(Q.tooltipArrowStyles), ft(Q.place));
    });
  }, [oe, W, Y, me, a, $ == null ? void 0 : $.place, u, v, K, $ == null ? void 0 : $.position, C]);
  B(() => {
    var p, S;
    const O = new Set(tt);
    be.forEach((A) => {
      O.add({ current: A });
    });
    const Q = document.querySelector(`[id='${i}']`);
    Q && O.add({ current: Q });
    const z = () => {
      ie(!1);
    }, t = Qt(W), c = Qt(J.current);
    ue.scroll && (window.addEventListener("scroll", z), t == null || t.addEventListener("scroll", z), c == null || c.addEventListener("scroll", z));
    let f = null;
    ue.resize ? window.addEventListener("resize", z) : W && J.current && (f = tr(W, J.current, Ae, { ancestorResize: !0, elementResize: !0, layoutShift: !0 }));
    const y = (A) => {
      A.key === "Escape" && ie(!1);
    };
    ue.escape && window.addEventListener("keydown", y), ue.clickOutsideAnchor && window.addEventListener("click", le);
    const g = [], j = (A) => {
      oe && (A == null ? void 0 : A.target) === W || Te(A);
    }, k = (A) => {
      oe && (A == null ? void 0 : A.target) === W && fe();
    }, T = ["mouseenter", "mouseleave", "focus", "blur"], ee = ["click", "dblclick", "mousedown", "mouseup"];
    Object.entries(rt).forEach(([A, se]) => {
      se && (T.includes(A) ? g.push({ event: A, listener: de }) : ee.includes(A) && g.push({ event: A, listener: j }));
    }), Object.entries(ot).forEach(([A, se]) => {
      se && (T.includes(A) ? g.push({ event: A, listener: lt }) : ee.includes(A) && g.push({ event: A, listener: k }));
    }), C && g.push({ event: "pointermove", listener: U });
    const M = () => {
      nt.current = !0;
    }, V = () => {
      nt.current = !1, fe();
    };
    return L && !xe && ((p = J.current) === null || p === void 0 || p.addEventListener("mouseenter", M), (S = J.current) === null || S === void 0 || S.addEventListener("mouseleave", V)), g.forEach(({ event: A, listener: se }) => {
      O.forEach((dt) => {
        var ce;
        (ce = dt.current) === null || ce === void 0 || ce.addEventListener(A, se);
      });
    }), () => {
      var A, se;
      ue.scroll && (window.removeEventListener("scroll", z), t == null || t.removeEventListener("scroll", z), c == null || c.removeEventListener("scroll", z)), ue.resize ? window.removeEventListener("resize", z) : f == null || f(), ue.clickOutsideAnchor && window.removeEventListener("click", le), ue.escape && window.removeEventListener("keydown", y), L && !xe && ((A = J.current) === null || A === void 0 || A.removeEventListener("mouseenter", M), (se = J.current) === null || se === void 0 || se.removeEventListener("mouseleave", V)), g.forEach(({ event: dt, listener: ce }) => {
        O.forEach((vn) => {
          var Lt;
          (Lt = vn.current) === null || Lt === void 0 || Lt.removeEventListener(dt, ce);
        });
      });
    };
  }, [W, Ae, ze, tt, be, I, re, ae, Ue]), B(() => {
    var p, S;
    let O = (S = (p = $ == null ? void 0 : $.anchorSelect) !== null && p !== void 0 ? p : s) !== null && S !== void 0 ? S : "";
    !O && n && (O = `[data-tooltip-id='${n}']`);
    const Q = new MutationObserver((z) => {
      const t = [], c = [];
      z.forEach((f) => {
        if (f.type === "attributes" && f.attributeName === "data-tooltip-id" && (f.target.getAttribute("data-tooltip-id") === n ? t.push(f.target) : f.oldValue === n && c.push(f.target)), f.type === "childList") {
          if (W) {
            const y = [...f.removedNodes].filter((g) => g.nodeType === 1);
            if (O)
              try {
                c.push(...y.filter((g) => g.matches(O))), c.push(...y.flatMap((g) => [...g.querySelectorAll(O)]));
              } catch {
              }
            y.some((g) => {
              var j;
              return !!(!((j = g == null ? void 0 : g.contains) === null || j === void 0) && j.call(g, W)) && ($e(!1), ie(!1), ke(null), Z.current && clearTimeout(Z.current), ne.current && clearTimeout(ne.current), !0);
            });
          }
          if (O)
            try {
              const y = [...f.addedNodes].filter((g) => g.nodeType === 1);
              t.push(...y.filter((g) => g.matches(O))), t.push(...y.flatMap((g) => [...g.querySelectorAll(O)]));
            } catch {
            }
        }
      }), (t.length || c.length) && Fe((f) => [...f.filter((y) => !c.includes(y)), ...t]);
    });
    return Q.observe(document.body, { childList: !0, subtree: !0, attributes: !0, attributeFilter: ["data-tooltip-id"], attributeOldValue: !0 }), () => {
      Q.disconnect();
    };
  }, [n, s, $ == null ? void 0 : $.anchorSelect, W]), B(() => {
    Ae();
  }, [Ae]), B(() => {
    if (!(H != null && H.current))
      return () => null;
    const p = new ResizeObserver(() => {
      setTimeout(() => Ae());
    });
    return p.observe(H.current), () => {
      p.disconnect();
    };
  }, [Y, H == null ? void 0 : H.current]), B(() => {
    var p;
    const S = document.querySelector(`[id='${i}']`), O = [...be, S];
    W && O.includes(W) || ke((p = be[0]) !== null && p !== void 0 ? p : S);
  }, [i, be, W]), B(() => (ve && ie(!0), () => {
    Z.current && clearTimeout(Z.current), ne.current && clearTimeout(ne.current);
  }), []), B(() => {
    var p;
    let S = (p = $ == null ? void 0 : $.anchorSelect) !== null && p !== void 0 ? p : s;
    if (!S && n && (S = `[data-tooltip-id='${n}']`), S)
      try {
        const O = Array.from(document.querySelectorAll(S));
        Fe(O);
      } catch {
        Fe([]);
      }
  }, [n, s, $ == null ? void 0 : $.anchorSelect]);
  const he = (Le = $ == null ? void 0 : $.content) !== null && Le !== void 0 ? Le : Y, We = oe && Object.keys(Je).length > 0;
  return wn(e, () => ({ open: (p) => {
    if (p != null && p.anchorSelect)
      try {
        document.querySelector(p.anchorSelect);
      } catch {
        return void console.warn(`[react-tooltip] "${p.anchorSelect}" is not a valid CSS selector`);
      }
    Ze(p ?? null), p != null && p.delay ? it(p.delay) : ie(!0);
  }, close: (p) => {
    p != null && p.delay ? Oe(p.delay) : ie(!1);
  }, activeAnchor: W, place: Ye, isOpen: !!(ze && !b && he && We) })), ze && !b && he ? Me.createElement(m, { id: n, role: yt, className: $t("react-tooltip", pt.tooltip, Pt.tooltip, Pt[l], r, `react-tooltip__place-${Ye}`, pt[We ? "show" : "closing"], We ? "react-tooltip__show" : "react-tooltip__closing", v === "fixed" && pt.fixed, L && pt.clickable), onTransitionEnd: (p) => {
    Pe.current && clearTimeout(Pe.current), oe || p.propertyName !== "opacity" || ($e(!1), Ze(null), D == null || D());
  }, style: { ...me, ...Je, opacity: Ge !== void 0 && We ? Ge : void 0 }, ref: J }, he, Me.createElement(m, { className: $t("react-tooltip-arrow", pt.arrow, Pt.arrow, o, E && pt.noArrow), style: { ...De, background: ut ? `linear-gradient(to right bottom, transparent 50%, ${ut} 50%)` : void 0 }, ref: we })) : null;
}, fr = ({ content: e }) => Me.createElement("span", { dangerouslySetInnerHTML: { __html: e } }), en = (e, n) => !("CSS" in window && "supports" in window.CSS) || window.CSS.supports(e, n), dr = Me.forwardRef(({ id: e, anchorId: n, anchorSelect: r, content: o, html: l, render: i, className: s, classNameArrow: a, variant: u = "dark", place: d = "top", offset: h = 10, wrapper: v = "div", children: x = null, events: m = ["hover"], openOnClick: w = !1, positionStrategy: R = "absolute", middlewares: C, delayShow: b = 0, delayHide: E = 0, float: L = !1, hidden: F = !1, noArrow: N = !1, clickable: te = !1, closeOnEsc: I = !1, closeOnScroll: re = !1, closeOnResize: ae = !1, openEvents: ge, closeEvents: me, globalCloseEvents: K, imperativeModeOnly: X = !1, style: D, position: Y, isOpen: H, defaultIsOpen: G = !1, disableStyleInjection: ve = !1, border: Re, opacity: W, arrowColor: ke, setIsOpen: Xe, afterShow: Ge, afterHide: ut, role: yt = "tooltip" }, Le) => {
  const [J, we] = q(o), [Z, ne] = q(l), [Pe, Ye] = q(d), [ft, Je] = q(u), [je, De] = q(h), [Qe, oe] = q(b), [Ne, ze] = q(E), [$e, $] = q(L), [Ze, et] = q(F), [He, tt] = q(v), [Se, nt] = q(m), [be, Fe] = q(R), [_e, Ue] = q(null), [xe, rt] = q(null), ot = Ee(ve), { anchorRefs: ue, activeAnchor: ie } = mn(e), it = (U) => U == null ? void 0 : U.getAttributeNames().reduce((le, _) => {
    var P;
    return _.startsWith("data-tooltip-") && (le[_.replace(/^data-tooltip-/, "")] = (P = U == null ? void 0 : U.getAttribute(_)) !== null && P !== void 0 ? P : null), le;
  }, {}), Oe = (U) => {
    const le = { place: (_) => {
      var P;
      Ye((P = _) !== null && P !== void 0 ? P : d);
    }, content: (_) => {
      we(_ ?? o);
    }, html: (_) => {
      ne(_ ?? l);
    }, variant: (_) => {
      var P;
      Je((P = _) !== null && P !== void 0 ? P : u);
    }, offset: (_) => {
      De(_ === null ? h : Number(_));
    }, wrapper: (_) => {
      var P;
      tt((P = _) !== null && P !== void 0 ? P : v);
    }, events: (_) => {
      const P = _ == null ? void 0 : _.split(" ");
      nt(P ?? m);
    }, "position-strategy": (_) => {
      var P;
      Fe((P = _) !== null && P !== void 0 ? P : R);
    }, "delay-show": (_) => {
      oe(_ === null ? b : Number(_));
    }, "delay-hide": (_) => {
      ze(_ === null ? E : Number(_));
    }, float: (_) => {
      $(_ === null ? L : _ === "true");
    }, hidden: (_) => {
      et(_ === null ? F : _ === "true");
    }, "class-name": (_) => {
      Ue(_);
    } };
    Object.values(le).forEach((_) => _(null)), Object.entries(U).forEach(([_, P]) => {
      var de;
      (de = le[_]) === null || de === void 0 || de.call(le, P);
    });
  };
  B(() => {
    we(o);
  }, [o]), B(() => {
    ne(l);
  }, [l]), B(() => {
    Ye(d);
  }, [d]), B(() => {
    Je(u);
  }, [u]), B(() => {
    De(h);
  }, [h]), B(() => {
    oe(b);
  }, [b]), B(() => {
    ze(E);
  }, [E]), B(() => {
    $(L);
  }, [L]), B(() => {
    et(F);
  }, [F]), B(() => {
    Fe(R);
  }, [R]), B(() => {
    ot.current !== ve && console.warn("[react-tooltip] Do not change `disableStyleInjection` dynamically.");
  }, [ve]), B(() => {
    typeof window < "u" && window.dispatchEvent(new CustomEvent("react-tooltip-inject-styles", { detail: { disableCore: ve === "core", disableBase: ve } }));
  }, []), B(() => {
    var U;
    const le = new Set(ue);
    let _ = r;
    if (!_ && e && (_ = `[data-tooltip-id='${e}']`), _)
      try {
        document.querySelectorAll(_).forEach((he) => {
          le.add({ current: he });
        });
      } catch {
        console.warn(`[react-tooltip] "${_}" is not a valid CSS selector`);
      }
    const P = document.querySelector(`[id='${n}']`);
    if (P && le.add({ current: P }), !le.size)
      return () => null;
    const de = (U = xe ?? P) !== null && U !== void 0 ? U : ie.current, lt = new MutationObserver((he) => {
      he.forEach((We) => {
        var p;
        if (!de || We.type !== "attributes" || !(!((p = We.attributeName) === null || p === void 0) && p.startsWith("data-tooltip-")))
          return;
        const S = it(de);
        Oe(S);
      });
    }), Ae = { attributes: !0, childList: !1, subtree: !1 };
    if (de) {
      const he = it(de);
      Oe(he), lt.observe(de, Ae);
    }
    return () => {
      lt.disconnect();
    };
  }, [ue, ie, xe, n, r]), B(() => {
    D != null && D.border && console.warn("[react-tooltip] Do not set `style.border`. Use `border` prop instead."), Re && !en("border", `${Re}`) && console.warn(`[react-tooltip] "${Re}" is not a valid \`border\`.`), D != null && D.opacity && console.warn("[react-tooltip] Do not set `style.opacity`. Use `opacity` prop instead."), W && !en("opacity", `${W}`) && console.warn(`[react-tooltip] "${W}" is not a valid \`opacity\`.`);
  }, []);
  let Te = x;
  const fe = Ee(null);
  if (i) {
    const U = i({ content: J ?? null, activeAnchor: xe });
    Te = U ? Me.createElement("div", { ref: fe, className: "react-tooltip-content-wrapper" }, U) : null;
  } else
    J && (Te = J);
  Z && (Te = Me.createElement(fr, { content: Z }));
  const Ie = { forwardRef: Le, id: e, anchorId: n, anchorSelect: r, className: $t(s, _e), classNameArrow: a, content: Te, contentWrapperRef: fe, place: Pe, variant: ft, offset: je, wrapper: He, events: Se, openOnClick: w, positionStrategy: be, middlewares: C, delayShow: Qe, delayHide: Ne, float: $e, hidden: Ze, noArrow: N, clickable: te, closeOnEsc: I, closeOnScroll: re, closeOnResize: ae, openEvents: ge, closeEvents: me, globalCloseEvents: K, imperativeModeOnly: X, style: D, position: Y, isOpen: H, defaultIsOpen: G, border: Re, opacity: W, arrowColor: ke, setIsOpen: Xe, afterShow: Ge, afterHide: ut, activeAnchor: xe, setActiveAnchor: (U) => rt(U), role: yt };
  return Me.createElement(ur, { ...Ie });
});
typeof window < "u" && window.addEventListener("react-tooltip-inject-styles", (e) => {
  e.detail.disableCore || Gt({ css: ":root{--rt-color-white:#fff;--rt-color-dark:#222;--rt-color-success:#8dc572;--rt-color-error:#be6464;--rt-color-warning:#f0ad4e;--rt-color-info:#337ab7;--rt-opacity:0.9;--rt-transition-show-delay:0.15s;--rt-transition-closing-delay:0.15s}.core-styles-module_tooltip__3vRRp{position:absolute;top:0;left:0;pointer-events:none;opacity:0;will-change:opacity}.core-styles-module_fixed__pcSol{position:fixed}.core-styles-module_arrow__cvMwQ{position:absolute;background:inherit}.core-styles-module_noArrow__xock6{display:none}.core-styles-module_clickable__ZuTTB{pointer-events:auto}.core-styles-module_show__Nt9eE{opacity:var(--rt-opacity);transition:opacity var(--rt-transition-show-delay)ease-out}.core-styles-module_closing__sGnxF{opacity:0;transition:opacity var(--rt-transition-closing-delay)ease-in}", type: "core" }), e.detail.disableBase || Gt({ css: `
.styles-module_tooltip__mnnfp{padding:8px 16px;border-radius:3px;font-size:90%;width:max-content}.styles-module_arrow__K0L3T{width:8px;height:8px}[class*='react-tooltip__place-top']>.styles-module_arrow__K0L3T{transform:rotate(45deg)}[class*='react-tooltip__place-right']>.styles-module_arrow__K0L3T{transform:rotate(135deg)}[class*='react-tooltip__place-bottom']>.styles-module_arrow__K0L3T{transform:rotate(225deg)}[class*='react-tooltip__place-left']>.styles-module_arrow__K0L3T{transform:rotate(315deg)}.styles-module_dark__xNqje{background:var(--rt-color-dark);color:var(--rt-color-white)}.styles-module_light__Z6W-X{background-color:var(--rt-color-white);color:var(--rt-color-dark)}.styles-module_success__A2AKt{background-color:var(--rt-color-success);color:var(--rt-color-white)}.styles-module_warning__SCK0X{background-color:var(--rt-color-warning);color:var(--rt-color-white)}.styles-module_error__JvumD{background-color:var(--rt-color-error);color:var(--rt-color-white)}.styles-module_info__BWdHW{background-color:var(--rt-color-info);color:var(--rt-color-white)}`, type: "base" });
});
const pr = "_tooltip_1xxpj_1", mr = "_arrow_1xxpj_18", tn = {
  tooltip: pr,
  arrow: mr
}, hr = (e) => /* @__PURE__ */ Rn.jsx(
  dr,
  {
    ...e,
    disableStyleInjection: !0,
    className: tn.tooltip,
    classNameArrow: tn.arrow
  }
);
export {
  hr as Tooltip
};
